import axios from 'axios'
// import es6Promise from 'es6-promise'
import qs from 'qs';
import Cookies from 'js-cookie'

// import { getUserInfo } from 'libs/utils/localStorage.js'
// import Message from 'common/utils/message'

// es6Promise.polyfill();//解决promiseIE不兼容

let instance = axios.create({
    //超时
    timeout: 60000,
    baseURL: '/sxtucaihui',
    // 设置请求头
    headers: {
        'userId':  Cookies.get('UserID')? Cookies.get('UserID')  : '',
        'orgGid':  Cookies.get('orgGid')? Cookies.get('orgGid')  : '',
        'token':  Cookies.get('token')? Cookies.get('token')  : '',
        'source':  Cookies.get('source')? Cookies.get('source')  : '',
        'datasource':  Cookies.get('logintype')? Cookies.get('logintype')  : '',   
    }
});

//获取用户信息
// let user = getUserInfo();
// if(user && user.token){
//     Object.keys(user).forEach(key =>{
//         let val = user[key];
//         if(val){
//             instance.defaults.headers.common[key] = encodeURI(val);
//         }
//     });
// }


// code状态码判断
instance.interceptors.response.use((res) => {
    //token失效
    if (res.data.TokenCode && res.data.TokenCode != 0) {
        location.replace('#/Login');  //token失效调整登录
    }
    if (res.data.code === '1000') {
        console.log('请求异常！');
        return Promise.reject({ type: -1, msg: res.data.msg, res: res.data });
    }
    if (res.status === 654) {
        console.log('请求超时！');
        return Promise.reject({ type: -1, msg: "请求超时！", res: res });
    }
    if (res.data.size && res.request.responseType == 'blob') {
        return res.data;
    }
    if (res.data.code === '2000') {
        return res.data;
    }
    if (res.data.code != '200') {
        // console.log('无权限操作！');
        // Message.info({title:'提示',message: res.errorMsg || res.data.errorMsg || "亲，服务器出小差啦，请稍后重试！", type:'error'});
        // return false;
    }
    // if (res.data.code != 200) {
    //     console.log('暂无数据！');
    //     return Promise.reject({type: 0, msg: res.data.msg || "亲，服务器出小差啦，请稍后重试！", res: res.data});
    // }
    return res.data;
}, (error) => {
    console.log('promise error:' + error);
    return Promise.reject({ type: -2, msg: "亲，服务器出小差啦，请稍后重试！", res: error })
});

//对POST请求数据做处理
instance.interceptors.request.use((res) => {

    if (res.method != "get" && res.method != "delete" && res.data) {
        if (res.data.responseType) {
            res.responseType = res.data.responseType;
            delete res.data.responseType;
        }
        if (res.headers['Content-Type'] == "application/json") {
            res.data = res.data.params
        } else {
            res.data = qs.stringify(res.data.params)
        }
    }
    return res;
});

export default instance;



// WEBPACK FOOTER //
// ./src/api/diyaxios.js